/* The not-found piece, drawn with the home's heading, text and link styles. Colors are theme tokens only. */
@layer telify {
  .notFound {
    padding-top: var(--sec);
  }

  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .text {
    margin-top: 20px;
    font-size: 17px;
    line-height: 1.65;
    color: var(--text-secondary);
    max-width: 42ch;
  }

  .home {
    margin-top: 32px;
  }

  @media (max-width: 1023px) {
    .notFound {
      padding-top: 96px;
    }
  }
}
